<script>
  // import Layout from '@layout/main'
  import { BRAND } from '@src/config/fake-data'
  import ContactLayout from './components/MenuList'

  export default {
    page() {
      return {
        title: `聯絡銷售人員 | 關於我們`,
      }
    },
    components: {
      ContactLayout,
    },
    props: {
      brands: {
        type: Array,
        default: () => {
          return []
        }
      }

    },
    data() {
      return {}
    },
    computed: {
      brandList() {
        return this.brands.filter((item) => {
          return item.alias !== 'zerone'
        })
      },
    },
  }
</script>
<template>
  <ContactLayout>
    <section :class="$style.sectionContactSales" class="section ">
      <div class="container">
        <div class="text-center mb-5">您可直接與我們銷售代表進行業務洽詢。</div>
        <ul :class="$style.contactList" class="row">
          <li v-for="(item, index) in brandList" :key="index" class="contactList__item col-md-6 col-xl-4">
            <div class="contactList__content">
              <img
                v-if="item.logo_image"
                alt=""
                class="contactList__logo"
                :src="item.logo_image"
              />
              <div v-else class="contactList__logo">{{ item.title }}</div>
              <div class="contactList__info">
                <div class="contactList__title">
                  {{ item.title }}
                </div>
                <div class="contactList__meta">
                  <ul class="list-unstyled">
                    <li v-for="(contact,$index2) in item.contact" :key="$index2">
                      ({{ contact.countryCode }}){{ contact.phone }} {{
                        contact.extension
                          ? `分機 ${ contact.extension }.`
                          : ''
                      }} {{ contact.name }}{{ contact.gender }}
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </li>
        </ul>
      </div>
    </section>
  </ContactLayout>
</template>
<style lang="scss" module>
  .sectionContactSales {
    .contactList {
      @include list-unstyled;

      :global {
        .contactList {
          &__item {
            margin-bottom: 10.25rem;

            @include max-md {
              margin-bottom: 2rem;
            }
          }

          &__content {
            display: flex;
            align-items: center;
            justify-content: center;
            padding-top: 60%;
            border: 1px solid $color-gray-3;

            @include max-md {
              flex-direction: column;
              padding-top: 0;
            }
          }

          &__info {
            position: absolute;
            bottom: 0;
            left: 50%;
            width: calc(100% - 100px);
            min-height: 147px;
            padding: 1.25rem;
            text-align: center;
            background: #F8F9FC;
            transform: translate(-50%, 50%);

            @include max-lg {
              width: 80%;
              padding: 1rem 0.5rem;
            }

            @include max-md {
              position: static;
              width: 100%;
              min-height: auto;
              transform: none;
            }
          }

          &__title {
            margin-bottom: 0.5rem;
            font-size: 1.5rem;
            font-weight: 500;
            letter-spacing: 0.05em;
            @include max-md {
              font-size: 1.25rem;
            }
          }

          &__meta {
            font-size: 0.875rem;

            ul {
              li {
                &:not(:last-child) {
                  margin-bottom: 0.4rem;
                }
              }
            }
          }

          &__logo {
            position: absolute;
            top: 50%;
            left: 50%;
            max-width: 70%;
            max-height: calc((100% - 40px) * 0.45);
            margin-top: -25px;
            transform: translate(-50%, -50%);

            @include max-md {
              position: static;
              margin: 1rem 0;
              transform: none;
            }
          }
        }
      }
    }
  }


</style>
